import React from 'react'
import cn from 'classnames'

import { Tile } from '@mc/design-system'
import { BREAKPOINTS } from '@mc/media'
import { paths } from '@mc/paths'
import { useStaticData } from '@mc/static-data-react'

import { CourseMeta, Outcome } from 'types/data'
import Image from 'components/LegacyImage'
import Link from 'components/Link/CustomLink'
import { useSubcategoryPageEvents } from '../../utils'
import styles from './InstructorTile.module.scss'

interface InstructorTileProps {
  courseMeta: CourseMeta
  colIdx: number
}

export const InstructorTile = ({ courseMeta, colIdx }: InstructorTileProps) => {
  const { outcomesBySlug, outcomeRanking } = useStaticData<{
    outcomesBySlug: Record<string, Outcome>
    outcomeRanking: string[]
  }>()

  const { trackInstructorTileClicked } = useSubcategoryPageEvents()

  const outcomeSlugsToShow = outcomeRanking
    .filter((outcomeSlug) => courseMeta.outcomeSlugs.includes(outcomeSlug))
    .slice(0, 3)

  return (
    <div className={styles.tile}>
      <Link
        ariaHidden
        href={paths.courseTypePage(
          courseMeta.contentType,
          courseMeta.courseSlug,
        )}
        tabIndex={-1}
        onClick={() =>
          trackInstructorTileClicked(colIdx, courseMeta.courseSlug)
        }
        passHref
        className='mc-mt-3'
      >
        <Tile aspectRatio='auto' className={styles.tileContent}>
          <Image
            objectFit='cover'
            src={courseMeta.instructorImgSrc}
            alt=''
            className='mc-corners--3'
            layout='fill'
            sizes={`(max-width: ${BREAKPOINTS.SM}px) 90vw, 25vw`}
          />
        </Tile>

        <div className={cn('mc-mt-3 mc-mb-4', styles.instructorInfo)}>
          <p className='mc-text-h6 mc-text--2-lines'>
            {courseMeta.instructorName}
          </p>
          <p className='mc-text-x-small mc-opacity--hinted mc-text--3-lines'>
            {courseMeta.instructorBio}
          </p>
        </div>
      </Link>
      <div className='d-flex flex-wrap'>
        {outcomeSlugsToShow.map((outcomeSlug, idx) => (
          <p
            className={cn(
              'mc-text-h8 mc-bg-container-tint-dark mc-mt-2',
              styles.outcomePill,
            )}
            key={idx}
          >
            {outcomesBySlug[outcomeSlug].name}
          </p>
        ))}
      </div>
    </div>
  )
}
